import React from "react";
import { useLocation } from "react-router-dom";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary" className="mx-auto mt-16 max-w-lg rounded-2xl border border-line bg-white p-8 text-center shadow-sm">
          <h1 className="mb-2 text-lg font-extrabold text-green">Une erreur est survenue</h1>
          <p className="mb-1 text-sm text-muted">Cette page a rencontré un problème inattendu. Vos données enregistrées ne sont pas affectées.</p>
          <p className="mb-5 break-all text-xs text-danger">{this.state.error.message}</p>
          <div className="flex justify-center gap-2">
            <button data-testid="error-boundary-retry-btn" className="nx-btn-ghost" onClick={() => this.setState({ error: null })}>
              Réessayer
            </button>
            <button data-testid="error-boundary-reload-btn" className="nx-btn-primary" onClick={() => window.location.reload()}>
              Recharger l'application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export function RouteErrorBoundary({ children }: { children: React.ReactNode }) {
  const loc = useLocation();
  return <ErrorBoundary key={loc.pathname}>{children}</ErrorBoundary>;
}
